import { ContentModelPopupDetails } from './contentModelPopupDetails.model';

export class ContentModelPopup {
  modelId: any;
  modelTitle: any;
  details: any;

  constructor(modelId: any, contentjson?: any) {
    if (contentjson) {
      this.modelId = modelId;
      if (contentjson['modelTitle']) {
        this.modelTitle = contentjson['modelTitle'];
      }
      this.details = this.fillDetails(contentjson);
    }
  }

  private fillDetails(contentjson?: any): any {
    let details: any;
    if (contentjson) {
      if (contentjson['modelId']) {
        switch (contentjson['modelId']) {
          case 'corporaterewardsecert': {
            details = new ContentModelPopupDetails(contentjson);
            break;
          }
          case 'negotiatedfaresecert': {
            details = new ContentModelPopupDetails(contentjson);
            break;
          }
          case 'corporaterewardsmcode': {
            details = new ContentModelPopupDetails(contentjson);
            break;
          }
          case 'negotiatedfaresmcode': {
            details = new ContentModelPopupDetails(contentjson);
            break;
          }
          default: {
            details = null;
            break;
          }
        }
      }
    }
    return details;
  }
}

export declare class ContentPageTitle {
  homePageTitle: string;
}
